import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import AdminDashboard from './Admin/Dashboard/AdminDashboard';
import LoginAdmin from './Admin/Login/LoginAdmin';
import UserDashboard from './User/Dashboard/UserDashboard';
import LoginUser from './User/Login/LoginUser';
import BuatAkunPage from './Admin/BuatAkunNasabah/BuatAkunPage';
import BuatPembayaranNasabah from './Admin/BuatPembayaranNasabah/BuatPembayaranNasabah';
import ListAkunNasabah from './Admin/ListAkunNasabah/ListAkunNasabah';

// Untuk user
function ProtectedRouteUser({ children }) {
  const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
  if (!token) return <Navigate to="/login-user" replace />;
  return children;
}
function RedirectIfAuthenticatedUser({ children }) {
  const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
  if (token) return <Navigate to="/dashboard" replace />;
  return children;
}

// Untuk admin
function ProtectedRouteAdmin({ children }) {
  const token = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
  if (!token) return <Navigate to="/login-admin" replace />;
  return children;
}
function RedirectIfAuthenticatedAdmin({ children }) {
  const token = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
  if (token) return <Navigate to="/admin/dashboard" replace />;
  return children;
}

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* User routes */}
        <Route path="/" element={<Navigate to="/login-user" />} />
        <Route
          path="/login-user"
          element={
            <RedirectIfAuthenticatedUser>
              <LoginUser />
            </RedirectIfAuthenticatedUser>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRouteUser>
              <UserDashboard />
            </ProtectedRouteUser>
          }
        />


        {/* Admin routes */}
        <Route
          path="/login-admin"
          element={
            <RedirectIfAuthenticatedAdmin>
              <LoginAdmin />
            </RedirectIfAuthenticatedAdmin>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRouteAdmin>
              <AdminDashboard />
            </ProtectedRouteAdmin>
          }
        />
        <Route path="/admin/buat-akun" element={<ProtectedRouteAdmin>
          <BuatAkunPage />
        </ProtectedRouteAdmin>
        }
        />
        <Route path="/admin/buat-pembayaran" element={<ProtectedRouteAdmin>
          <BuatPembayaranNasabah />
        </ProtectedRouteAdmin>} />

        <Route path="/admin/list-akun" element={<ProtectedRouteAdmin>
          <ListAkunNasabah />
        </ProtectedRouteAdmin>} />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <Router>
      <AnimatedRoutes />
    </Router>
  );
}
